import React, { useState } from 'react';
import './App.css';
import BetaInput from './components/BetaInput';
import PortfolioResults from './components/PortfolioResults';
import Footer from './components/Footer';
import SimpleApp from './SimpleApp';
import OptimizedApp from './OptimizedApp';
import { api } from './api';

function App() {
  const [appVersion, setAppVersion] = useState('optimized'); // 'simple', 'optimized', 'full'
  const [numStocks, setNumStocks] = useState(10);
  const [beta, setBeta] = useState(0.95);
  const [performance, setPerformance] = useState('8%');
  const [portfolioData, setPortfolioData] = useState(null);
  const [loading, setLoading] = useState(false);

  const optimizePortfolio = async () => {
    if (numStocks < 1 || numStocks > 500) {
      alert('Please enter a valid number of stocks (1-500)');
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post('/optimize', {
        num_stocks: parseInt(numStocks),
        target_beta: parseFloat(beta),
        performance: performance
      });
      setPortfolioData(data);
    } catch (error) {
      console.error('Error optimizing portfolio:', error);
      const message = error.response?.data?.message || error.message;
      alert(`Error optimizing portfolio: ${message}`);
    } finally {
      setLoading(false);
    }
  };

  if (appVersion === 'simple') {
    return <SimpleApp />;
  }

  if (appVersion === 'optimized') {
    return <OptimizedApp />;
  }

  return (
    <div id="app-full" className="App">
      <div id="container-full" className="container">
        <h1 id="title-full">Portfolio Optimizer</h1>
        <div id="version-switcher" style={{ marginBottom: '20px' }}>
          <button 
            id="btn-version-optimized"
            onClick={() => setAppVersion('optimized')}
            style={{ 
              padding: '10px 20px', 
              marginRight: '10px',
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            🚀 Optimized Version (Recommended)
          </button>
          <button 
            id="btn-version-simple"
            onClick={() => setAppVersion('simple')}
            style={{ 
              padding: '10px 20px',
              marginRight: '10px',
              backgroundColor: '#2196F3',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            ⚡ Simple Version
          </button>
          <button 
            id="btn-version-full"
            onClick={() => setAppVersion('full')}
            style={{ 
              padding: '10px 20px',
              backgroundColor: '#FF9800',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            🔧 Full Version
          </button>
        </div>
        
        <div id="input-section-full" className="input-section">
          <div id="stocks-section-full" className="stocks-section">
            <h3 id="stocks-heading-full">Portfolio Settings</h3>
            <div id="stock-input-group-full" className="stock-input-group">
              <label id="label-num-stocks-full" htmlFor="num-stocks-full">How many stocks?</label>
              <input
                id="num-stocks-full"
                type="number"
                placeholder="10"
                value={numStocks}
                onChange={(e) => setNumStocks(e.target.value)}
                min="1"
                max="500"
                className="stock-input"
              />
            </div>
          </div>

          <div id="beta-section-full" className="beta-section">
            <BetaInput value={beta} onChange={setBeta} />
          </div>

          <div id="performance-section-full" className="performance-section">
            <h3 id="performance-heading-full">Performance</h3>
            <div id="performance-input-group-full" className="performance-input-group">
              <label id="label-performance-full" htmlFor="performance-full">Performance</label>
              <input
                id="performance-full"
                type="text"
                placeholder="8%"
                value={performance}
                onChange={(e) => setPerformance(e.target.value)}
                className="performance-input"
              />
            </div>
          </div>

          <div id="optimize-section-full" className="optimize-section">
            <button 
              id="btn-optimize-full"
              onClick={optimizePortfolio} 
              disabled={loading}
              className="optimize-btn"
            >
              {loading ? 'Optimizing...' : 'Optimize Portfolio'}
            </button>
          </div>
        </div>

        {portfolioData && (
          <div id="portfolio-results-wrapper-full">
            <PortfolioResults data={portfolioData} />
          </div>
        )}

        <Footer />
      </div>
    </div>
  );
}

export default App;
